module.exports = __webpack_public_path__ + "img/brest-logo-icon.f3fdc5e2.png";